import { Skeleton } from 'iuvity-ui-components/dist/skeleton'
import styles from '../login.module.scss'

const LoginSkeleton = () => {
	return (
		<div className={styles.skeletonWrapper}>
			<div className={styles.skeleton}>
				<Skeleton height='31px' width='100px' className='mb-2' />
				<br />
				<Skeleton height='20px' width='80px' className='mb-2' />
				<Skeleton height='40px' width='20.125rem' />
				<br />
				<Skeleton height='16px' width='80px' className='mb-2' />
				<Skeleton height='40px' width='20.125rem' />
				<br />
				<div className='flex justify-content-center' style={{
                    width: '20.125rem'
                }}>   
					<Skeleton height='60px' width='122px' className='ml-0' />
				</div>
			</div>
		</div>
	)
}

export default LoginSkeleton